import {
  DiseaseRiskV2CommonProps,
  RecommendationExistenceInfo,
  hasDiseaseRiskOption,
} from "../commons";
import MedicalFacilityReport from "./MedicalFacilityReport";

/**
 * {@link DiseaseRiskReport2} のプロパティ
 */
export interface DiseaseRiskReportProps extends DiseaseRiskV2CommonProps {
  /** {@link RecommendationExistenceInfo} */
  existence: RecommendationExistenceInfo;
}
/**
 * 疾患リスクレポート
 *
 * @param param0 {@link DiseaseRiskReport2Props}
 * @returns 疾患リスクレポート
 */
export default function DiseaseRiskReport({
  data,
  existence,
}: DiseaseRiskReportProps) {
  // 受診勧奨オプション OFF の場合は表示なし
  if (!hasDiseaseRiskOption(existence)) return <></>;
  return (
    <>
      <MedicalFacilityReport data={data} existence={existence} />
    </>
  );
}
